module.exports = __webpack_public_path__ + "static/media/partnership.dbf6649f.png";